<template>
  <div class="search-wrapper">
    <el-form ref="form" :inline="true" v-model="searchForm">
      <el-form-item label="">
        <el-date-picker
          style="width: 230px"
          v-model="date"
          :clearable="false"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="">
        <el-cascader
          :key="Math.random()"
          style="width: 230px"
          placeholder="请选择用户"
          v-model="loginIds"
          :options="userList"
          :props="{ multiple: true, value: 'loginId', label: 'name' }"
          filterable
          collapse-tags
          clearable
          @change="handleSearch"
        >
        </el-cascader>
      </el-form-item>

      <el-form-item label="">
        <el-select
          v-model="searchForm.platform"
          style="width: 210px"
          placeholder="请选择登陆平台"
          filterable
          clearable
          @change="handleSearch"
        >
          <el-option
            v-for="item in platformList"
            :key="item.platform"
            :label="item.platformName"
            :value="item.platform"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="">
        <el-cascader
          style="width: 210px"
          placeholder="请选择模块"
          v-model="searchForm.menuArr"
          :options="menuList"
          :props="{ multiple: true, value: 'name', label: 'name' }"
          collapse-tags
          clearable
          @change="handleSearch"
        >
        </el-cascader>
      </el-form-item>

      <el-form-item label="">
        <el-select
          v-model="searchForm.result"
          style="width: 210px"
          placeholder="请选择操作结果"
          clearable
          @change="handleSearch"
        >
          <el-option
            v-for="item in statusList"
            :key="item.statusId"
            :label="item.status"
            :value="item.statusId"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment';
import { platformList, statusList } from './dataOptions';
import service from '@/services/api/backstage';
import lodash from 'lodash';

export default {
  data() {
    return {
      platformList,
      statusList,
      date: null,
      loginIds: [],
      searchForm: {
        startDate: null,
        endDate: null,
        loginIds: [],
        platform: null,
        menuArr: [],
        typeIds: [],
        result: null,
      },
      userList: [],
      menuList: [],
    };
  },
  watch: {
    date: {
      handler(newVal, oldVal) {
        const start = moment(newVal[0]);
        const end = moment(newVal[1]);
        const diff = end.diff(start, 'day');
        if (diff > 31) {
          this.$message.error(
            '最多支持查询31天的数据，需要更长周期的数据，请联系开发人员!',
          );
          this.date = oldVal;
        } else {
          this.date = newVal;
          this.searchForm.startDate = this.date[0];
          this.searchForm.endDate = this.date[1];
          this.$emit('handle-search');
        }
      },
    },
  },
  async mounted() {
    await this.handleInitDate();
    await this.handleInitMenuData();
    await this.handleInitUserData();
  },
  methods: {
    async handleInitMenuData() {
      const { data } = await service.apiGetMenuTree();
      this.menuList = this.handleConvertMenuList(data.data);
    },
    // 后端返回的children里可能有空数组 删掉空数组
    handleConvertMenuList(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item.children.length === 0) {
            delete item.children;
          }
          this.handleConvertMenuList(item.children);
        });
      }
      return arr;
    },
    async handleInitUserData() {
      const { data } = await service.apiGetUserTree();
      this.userList = data.data;
      this.handleInitTree(this.userList);
    },
    handleInitTree(tree) {
      tree.forEach((item) => {
        item.children = [...item.userList, ...item.teamList];
        if (item.teamList.length) {
          item.teamList.forEach((team) => {
            team.children = [...team.teamList, ...team.userList];
          });
        }
        this.handleInitTree(item.teamList);
      });
    },
    handleInitDate() {
      this.date = [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD'),
      ];
      this.searchForm.startDate = this.date[0];
      this.searchForm.endDate = this.date[1];
    },
    handleSearch() {
      if (this.loginIds) {
        const arr = new Set(this.loginIds.flat(Infinity));
        this.searchForm.loginIds = lodash.compact([...arr]);
      }
      this.$emit('handle-search');
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-select__tags-text .el-tag {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-cascader__tags {
  max-width: 100px;
  flex-wrap: nowrap;
}
</style>
